<template lang="pug">
  div
    MHeader(
      page-title="Submit Single Link"
    )
    div( v-if="loading" ) Loading...
    div( v-else class="wrapper wrapper-content" )
      div( class="tabs-container" )
        div( class="tab-content" )
          div( v-bind:class="[ 'tab-pane', currentTab === 'single-with-data' && 'active' ]" )
            div( class="panel-body" )
              MForm( v-on:submit="submitLink" submit-text="Submit Link" )
                MModalButton( button-classes="btn-link font-bold" modal-size="modal-lg" title="Single Link Submission" )
                  span( slot="button-inner" )
                    | Help Panel
                    i( class="fa fa-question inline-block ml-2" )
                  p( slot="body" class="text-left font-normal" )
                    ul
                      p The following fields are compulsory:
                      p Affiliate link, Network choice, Advertiser name, Country Code and Submission name. 
                      p The Submission description is optional.
                      p Tags A to E can be completed to aid your categorisation for analysis.
  
                      p Cookie name and Cookie Type can be specified to override default network first party cookie parameters, and indeed those in the 'Advertiser Information'.
                      p The cookie type is either 'ANI' which means the cookie includes the Affiliate Network Identifier or 'wildcard' where it does not.  Wildcard might be selected if the advertiser is using a GUID cookie methodology.
                MInput(
                  type="text"
                  required
                  name="batchName"
                  label="Advertiser Name"
                )
                MInput(
                  type="text"
                  name="batchDescription"
                  label="Comment"
                )
                MInput(
                  type="text"
                  required
                  name="link"
                  label="Affiliate Link"
                )
                MInput(
                  type="select"
                  name="userDefinedNetwork"
                  required
                  v-bind:options="networks.map(n => ({ label: n.name, value: n.name }))" 
                  label="Network" 
                  v-on:change="onNetworkChange"
                )
                div( class="alert alert-warning text-center" v-if="showLinkConnectorReferrerWarning" )
                  | The selected network may require the "Referrer" which can be set in "Additional Fields" below
                MInput(
                  type="select"
                  required
                  name="countryCode"
                  v-bind:options="countryCodes"
                  value="gb"
                  label="Country Code"
                )
                  MModalButton( slot="description" container-classes="d-inline" button-classes="btn-link font-bold" modal-size="modal-lg" title="Choosing a Queue" )
                    span( slot="button-inner" )
                      |
                      i( class="fa fa-question inline-block ml-2" )
                    p( slot="body" class="text-left font-normal" )
                      ul
                        p Moonpull asks you to select a Country Code for link submission.
                        p Moonpull utilises data centres in approximately 50 counties, with the data centre specified within the submission data using the relevant ISO Alpha-2 code. 
                        p If you choose a country for which Moonpull is not confgured it will default to the UK (ISO code GB).
                        p For more details on the territories for which Moonpull is configured please contact your Moonpull lead.
                        p Moonpull provides a badge in the Audit Results Details to confirm the data centre that was used.
                div( class="form-group row")
                  div( class="ml-3 d-flex align-items-center" )
                    input( type="checkbox" v-model="batchMeta.notifyOnComplete" )
                  label( class="col-sm-10 col-form-label" ) Send email notification on completion
          div( v-bind:class="[ 'tab-pane', currentTab === 'single' && 'active' ]" )
            div( class="panel-body text-right" )
              p( class="text-left" ) Audit a single link
              input(
                class="form-control"
                type="text"
                placeholder="Enter an affiliate link"
                v-model="singleLink"
                v-bind:class="[ isSingleLinkValid() === false && singleLink.length !== 0 && 'is-invalid' ]"
              )
              div( class="invalid-feedback" v-if="isSingleLinkValid() === false && singleLink.length !== 0" ) Please enter a valid affiliate URL
              button(
                class="btn btn-primary mt-2 mr-0"
                v-bind:disabled="isSingleLinkValid() === false || loading"
                v-on:click="audit"
              )
                i( class="fa fa-spinner fa-spin mr-2" v-if="loading" )
                | Check Link
</template>

<script>
import Vue from 'vue'
import gql from 'graphql-tag'
import { countryCodes } from '@/countryCodes'
export default Vue.extend({
  

  data() {
    return {
      countryCodes,
      networks: [],
      currentTab: 'single-with-data',
      loading: true,
      singleLink: '',
      singleLinkValidationMessage: null,
      
      csv: null,
      fileUploadError: '',
      
      cookieTypeOptions: [
        {
          value: null,
          label: 'None',
        },
        {
          value: '1',
          label: 'ANI'
        },
        {
          value: '3',
          label: 'Wildcard'
        }
      ],

      gdprOptions: [
        {
          value: 'n',
          label: 'N'
        },
        {
          value: 'y',
          label: 'Y'
        }
      ],
      
      timeoutOptions: [
        {
          value: 'Yes',
          label: 'Yes'
        },
        {
          value: 'No',
          label: 'No'
        },
      ],
      networkOptions: [
        { value: 'awin', label: 'Awin'}
      ],

      validBatchName: true,

      batchMeta: {
        queueLetter: null,
        mobile: false,
        proxy: 'gb',
        userAgent: true,
        useResidentialProxy: false,
        notifyOnComplete: true,
        standDownMrAs: false,
      },
      linkView: false,
      showLinkConnectorReferrerWarning: false,
    }
  },
  watch: {
    ['batchMeta.name']() {
      this.validBatchName = !! this.batchMeta.name
    }
  },

  methods: {

    validateLink(link) {
      // TODO: More rigid validation checks for links
      return link.startsWith('http')
    },

    isSingleLinkValid() {
      return this.validateLink(this.singleLink)
    },

    onNetworkChange(e) {
      this.showLinkConnectorReferrerWarning = [ 'LinkConnector', 'LC Naked' ].includes(e.target.value)
    },

    audit() {
      if (! this.isBatchNameValid()) return
      if (! this.noDescriptionConfirmation()) return

      if (this.isSingleLinkValid() && this.isBatchNameValid()) {
        this.loading = true
        this.$moonpull.audit([{
          link: this.singleLink,
          countryCode: this.batchMeta.proxy,
          proxyYN: this.batchMeta.useResidentialProxy,
        }], this.batchMeta)
          .then(newBatch => {
            if (newBatch) {
              this.$router.push({ name: 'reporting-batch', params: { batchId: newBatch.batchId } })
            }
            this.loading = false
          })
      }
    },

    submitLink(data) {
      analytics.track("Single Link Uploaded", {})

      // Cookie name/type must both be specified or neither
      if ((data.cookieName && ! data.cookieType) || (! data.cookieName && data.cookieType)) {
        this.$store.dispatch('flashMessage', { type: 'warning', msg: `Cookie Name and Cookie Type must both be specified, if at all.` })
        return
      }
      // Check for valid URL
      try {
        new URL(data.link)
      } catch (e) {
        this.$store.dispatch('flashMessage', { type: 'danger', msg: `Invalid affiliate link. Please make sure the link is a valid URL.` })
        return
      }

      // Post the audit
      this.loading = true
      this.$moonpull.audit([data], {
        ...this.batchMeta,
        name: data.batchName,
        description: data.batchDescription,
      })
        .then(newBatch => {
          if (newBatch) {
            this.$router.push({ name: 'reporting-batches', query: { newBatch: newBatch.batchId } })
          }
          this.loading = false
        })
      this.$emit('dismissModals')
    },

  },
  async beforeMount() {

    // Load networks
    this.networks = await this.$moonpull.getNetworks(this.$apollo)

    const companyQueryRes = await this.$apollo.query({
      query: gql`
        query CompanyById($id: ID!) {
          companyById(id: $id) {
            id
            name
            resetDay
            nextResetDate
            numMonthlyLinks
            numExtraMonthlyLinks
            maxBatchSize
            numAudits
            remainingAudits
            queues
          }
        }
      `,
      variables: {
        id: this.$moonpull.getCurrentUserSession().company.id
      }
    })
    this.company = companyQueryRes.data.companyById
    if (this.company && this.company.queues && this.company.queues[0]) {
      this.batchMeta.queueLetter = this.company.queues[0]
    }
    this.loading = false
  },
})
</script>